<template>
	<div>
		<!-- <div style="margin-bottom: 20px;">
			<el-button size="small" @click="addTab(editableTabsValue)">
				添加页面
			</el-button>
		</div> -->
		<el-tabs v-model="editableTabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab">
			<el-tab-pane v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name">
				<!-- {{item.content}} -->
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	export default {
		name: "tagview",
		data() {
			return {
				editableTabsValue: '/', // 当前选中页面
				editableTabs: [{
					title: '主页',
					name: '/',
					content: '主页 content'
				}],
				tabIndex: 1 // 总页面
			}
		},
		methods: {
			// 添加标签页
			addTab(targetName) {
				let newTabName = ++this.tabIndex + '';
				this.editableTabs.push({
					title: targetName.title,
					name: targetName.path,
					content: targetName.path
				});
				this.editableTabsValue = targetName.path;
			},
			// 选中标签页
			clickTab(){
				// 如果不是等于当前路由的话，切换路由
				if(this.now_url != this.editableTabsValue){
					this.$router.push({
						path: this.editableTabsValue
					});
				}
			},
			// 删除标签页
			removeTab(targetName) {
				// 首页不能删除
				if(targetName == '/'){return;}
				
				let tabs = this.editableTabs; // 所有页面
				let activeName = this.editableTabsValue;// 当前显示的页面
				
				if (activeName === targetName) {
					tabs.forEach((tab, index) => {
						if (tab.name === targetName) {
							let nextTab = tabs[index + 1] || tabs[index - 1];
							if (nextTab) {
								activeName = nextTab.name;
							}
						}
					});
				}

				this.editableTabsValue = activeName;
				this.editableTabs = tabs.filter(tab => tab.name !== targetName);
				
				this.$store.commit('delete_tabs', targetName);
				
				if (this.activeIndex === targetName) {
					// 设置当前激活的路由
					if (this.openTab && this.openTab.length >= 1) {
						this.$store.commit('set_active_index', this.openTab[this.openTab.length - 1].route);
						this.$router.push({
							path: this.activeIndex
						});
					} else {
						this.$router.push({
							path: '/'
						});
					}
				}
			}
		},
		mounted() {
			this.now_url = this.$route.path;
			// 刷新时以当前路由做为tab加入tabs
			// 当前路由不是首页时，添加首页以及另一页到store里，并设置激活状态
			// 当当前路由是首页时，添加首页到store，并设置激活状态
			if (this.$route.path != '/') {
				this.$store.commit('add_tabs', {
					route: '/',
					name: '主页'
				});
				this.$store.commit('add_tabs', {
					route: this.$route.path,
					name: this.$route.meta.title
				});
				this.$store.commit('set_active_index', this.$route.path);
				let tn = {'title':this.$route.meta.title,'path':this.$route.path};
				this.addTab(tn);
			} else {
		
				this.$store.commit('add_tabs', {
					route: '/',
					name: '主页'
				});
				this.$store.commit('set_active_index', '/');
				// this.$router.push('/');
			}
		},
		computed: {
			openTab() {
				return this.$store.state.openTab;
			},
			activeIndex: {
				get() {
					return this.$store.state.activeIndex;
				},
				set(val) {
					this.$store.commit('set_active_index', val);
				}
			}
		},
		watch: {
			'$route'(to, from) { // 监听路由变化
				this.now_url = this.$route.path;
				
				//判断路由是否已经打开
				let flag = false;
				for (let item of this.openTab) {
					if (item.name === to.meta.title) {
						// 已经打开的 ，将其置为active
						this.$store.commit('set_active_index', to.path)
						flag = true;
						break;
					}
				}
				// 如果未打开，添加标签页 这里先默认全部打开
				if (!flag) {
					let tn = {'title':to.meta.title,'path':to.path};
					this.addTab(tn);
					//未打开的，将其放入队列里
					this.$store.commit('add_tabs', {
						route: to.path,
						name: to.meta.title
					});
					this.$store.commit('set_active_index', to.path);
				}else{
					this.editableTabsValue = to.path;
				}
				
		
			}
		},
	}
</script>

<style scoped>

</style>
